import { render, staticRenderFns } from "./AddVendorForm3.vue?vue&type=template&id=63495bdb"
import script from "./AddVendorForm3.vue?vue&type=script&lang=js"
export * from "./AddVendorForm3.vue?vue&type=script&lang=js"
import style0 from "./AddVendorForm3.vue?vue&type=style&index=0&id=63495bdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports